export default __webpack_public_path__ + "static/media/Group-146-Yono.93f45520.png";